import { render } from "./AdminManagement.vue?vue&type=template&id=79838862"
import script from "./AdminManagement.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdminManagement.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script